import { ProgramTypes } from 'legacy/lut/classes/models/ProgramTypes'

import { getAvailableProgramTypes } from 'partner360/helpers/offerings/getAvailableProgramTypes'
import { getOfferingsInfo } from 'partner360/helpers/offerings/getOfferingsInfo'

import { ICockpitPartnerOfferingsCatalog } from '../model/types'

import { getOfferingOrderMap } from './getOfferingOrderMap'

export interface ICockpitEnabledOffering {
  offering: ProgramTypes
  offeringName: string
}

/** Union of enabled, non-deprecated offerings across every partner in the catalog —
 *  same filtering `getManagerOfferingsInfo` applies for the offering tab strip. */
export const getEnabledCockpitOfferings = (
  offeringsCatalog: ICockpitPartnerOfferingsCatalog[]
): ICockpitEnabledOffering[] => {
  const offeringNames = new Map<ProgramTypes, string>()

  offeringsCatalog.forEach(({ offerings }) => {
    const { enabledOfferings } = getOfferingsInfo(getAvailableProgramTypes(offerings))
    enabledOfferings.forEach(({ programType, translation }) => {
      if (!offeringNames.has(programType)) offeringNames.set(programType, translation)
    })
  })

  const orderByOffering = getOfferingOrderMap(offeringsCatalog)

  return Array.from(offeringNames, ([offering, offeringName]) => ({ offering, offeringName })).sort(
    (a, b) => orderByOffering.get(a.offering)! - orderByOffering.get(b.offering)!
  )
}
